import React from 'react';

import SideMenu from '../../components/SideMenu';
import Footer from '../../components/Footer';
import Quotes from '../../components/Quotes';
import { getTranslations } from '../../services/languageUtils';

class Item extends React.Component {
  constructor(props) {
      super(props);

      this.state = {
        type: 'copyAndPaste',
        step: 0,
        translations: {}
      };
  }

  componentDidMount() {
    this.loadTranslations();
  }

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  onChangeValue = event => {
    switch(event.target.name){
      case 'step':
        this.setState({step: event.target.value});
        break;

      default:
        break;
    }
  }

  render() {
    return (
     <section id="userPage" className="userPage transactionPage">
       <SideMenu />
 
       <div className="contentData">
         <div className="contentScroll">
         <Quotes />
         <p className="breadcrumb"><b><span style={{color: "#1c787e"}}>{this.state.translations.home} </span> | {this.state.translations.exchange}</b></p><br/>
         <p className="title"><span style={{fontWeight: "normal"}}></span> {this.state.translations.exchange}</p><br/>
 
         <div className="contentSubData">
         </div>
 
         <Footer />
         </div>
       </div>
     </section>
    );
 }
 }

export default Item;
